var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 30h24M8 20h24M8 10h24","stroke":"#fff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Menu.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
